import { Outlet, Navigate } from "react-router-dom";
import { useStyle } from "../../context/styleContext/styleContext";
import {useContext, useState, useEffect} from "react";
import {useNavigate} from 'react-router-dom'
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';


export default function LoadingSpinner(){

    const { style } = useStyle();
    

    return(<>

    
    <div style={{ textAlign:'center', width:'60%', maxWidth:'300px', alignContent:'center', alignItems:'center', margin:'auto'}}>
        <CircularProgress sx={{color:style.color2}} size='50%' />
        <h1 style={{color:style.color2}}>Loading...</h1>
    </div>


    </>)

}